import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-scroll-view',
  templateUrl: 'scroll-view.component.html',
  styleUrls: ['scroll-view.component.scss'],
  host: {
    '[class.scrollable-vertical]': '!!(vertical && scrollable)',
    '[class.scrollable-horizontal]': '!!(horizontal && scrollable)',
  },
})
export class ScrollViewComponent {
  @Input()
  scrollable = true;

  @Input()
  vertical = true;
  @Input()
  horizontal = false;
}
